<template>
  <div>
    <GmapMap
    :center="{lat:38.470256, lng:-98.795222}"
    :zoom="4"
    :options="{
      streetViewControl: false,
      mapTypeControl: false
    }"
    class="ratio ratio-16x9"
    @click="infoWinOpen=false"
  >
    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"></gmap-info-window>
    <GmapMarker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :draggable="true"
        :clickable="true" 
        @click="toggleInfoWindow(m,i)"
      />

  </GmapMap>
</div>
</template>

<script>

export default {
  data() {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
      content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
    }
  },
  mounted() {
    this.markers = local_examples
  },
  methods: {
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = 
      `<p><strong>${marker.position.title}</strong></p>
      ${marker.position.description}`;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    }
  }
}
</script>